import React, { useMemo, useState } from 'react';
import { DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { DefaultView } from './DefaultView.js';
import { DragHandle, SortableItem } from './SortableItem.js';
import { SortableOverlay } from './SortableOverlay.js';
import { reorder } from './utils.js';
const Sortable = (props) => {
    const { id, items, onDragEnd, renderItem, disabled = false } = props;
    const [active, setActive] = useState(null);
    const activeItem = useMemo(() => items.find(item => item.id === (active === null || active === void 0 ? void 0 : active.id)), [active, items]);
    const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    }));
    return (React.createElement(DndContext, { sensors: sensors, modifiers: [restrictToVerticalAxis], onDragStart: ({ active }) => {
            setActive(active);
        }, onDragEnd: ({ active, over }) => {
            if (over && active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
                const activeIndex = items.findIndex(({ id }) => id === active.id);
                const overIndex = items.findIndex(({ id }) => id === over.id);
                onDragEnd({
                    source: {
                        index: activeIndex,
                    },
                    destination: overIndex !== -1 && {
                        index: overIndex,
                    },
                });
            }
            setActive(null);
        }, onDragCancel: () => {
            setActive(null);
        } },
        React.createElement(SortableContext, { items: items, disabled: disabled },
            React.createElement("ul", { className: "flex flex-col space-y-2", role: "application", id: id }, items.map((item, index) => (React.createElement(React.Fragment, { key: item.id }, renderItem(item, index)))))),
        React.createElement(SortableOverlay, null, activeItem ? renderItem(activeItem, -1) : null)));
};
export const SortableList = Object.assign(Sortable, {
    Item: SortableItem,
    Handle: DragHandle,
    DefaultView,
    reorder,
});
//# sourceMappingURL=SortableList.js.map